
import { ArrowsLeftRightIcon, CardsThreeIcon, CurrencyDollarIcon, ExclamationMarkIcon, UsersIcon, WalletIcon } from '@phosphor-icons/react'
import TransactionHistory from './component/TransactionHistory';
import ActiveTradingAccountList from './component/AccountTable';
import StatsCard from './component/StatsCard';
//import '../../../tailwind.css'
import UserAccountList from './component/UserAccountList';
import SidebarLayout from 'components/Layout/Layout';
import { useTheme } from 'components/provider/theme';
import { useEffect, useState } from 'react';
import { API_URL } from 'env';
import { useData } from 'components/provider/data';
import TradeHistoryChartLine from 'components/Chart/tradeHistoryChartLine';
import { Button, Divider } from 'antd';
import TradeHistoryChartBar from 'components/Chart/tradeHistoryChartBar';
import ProfitChartByUser from 'components/Chart/profitChartbyUser';

const MainDashBoard = () => {
    const { theme } = useTheme()
    const { total_balance, total_trade, allAccountBalance, totalAccounts, activeUsers } = useData();

    async function fetchUserAccount(id: string, platform: string) {
        try {
            const response = await fetch(`https://fund-forge-api.wealthfarming.org/${platform.replace('4', '5')}/live-trading?account_number=${id}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                }
            });
            if (!response.ok) {
                console.error('Failed to fetch user account:', response.statusText);
            }
            else {
                const data = await response.json();

                return {
                    balance: Number(data.data.balance) || 0,
                    equity: Number(data.data.equity) || 0,
                    pl: Number(data.data.profit) || 0,
                }

            }
        } catch (error) {
            console.error('Error fetching user account:', error);
            return null;
        }
    }

    // async function fetchTotalBalance() {
    //     try {
    //         const response = await fetch(`${API_URL}api/v1/be/trade_accounts`, {
    //             method: 'GET',
    //             headers: {
    //                 'Content-Type': 'application/json',
    //                 'Authorization': `Bearer ${localStorage.getItem('token')}`
    //             }
    //         });
    //         if (!response.ok) {
    //             throw new Error('Network response was not ok');
    //         }
    //         const data = await response.json();
    //         for (const account of data.data.items) {
    //             const accountData = await fetchUserAccount(account.account_number, account.platform);
    //             if (accountData) {
    //                 setTotalBalance(prevBalance => prevBalance + accountData.balance);
    //             }
    //         }
    //     } catch (error) {
    //         console.error('Error fetching total balance:', error);
    //     }
    // }

    return (
        <SidebarLayout
            title={(
                <h4 className={`text-2xl font-bold !m-0 ${theme === "light" ? 'text-gray-800' : ''} py-4`}>
                    Overview Dashboard
                </h4>
            )}
        >
            <div className="grid lg:!grid-cols-4 md:!grid-cols-3 grid-cols-1  gap-4 w-full px-4 ">
                <StatsCard
                    title="Total Accounts"
                    icons={<CardsThreeIcon size={24} />}
                    iconsBackground={theme === "dark" ? '#2563eb' : ''}
                    value={totalAccounts}
                    valueType="number"
                />
                <StatsCard
                    title="Total Users"
                    icons={<UsersIcon size={24} />}
                    iconsBackground={theme === "dark" ? '#2563eb' : ''}
                    value={activeUsers}
                    valueType="number"
                />
                <StatsCard
                    title="Total Balance"
                    icons={<WalletIcon size={24} />}
                    iconsBackground={theme === "dark" ? '#2563eb' : ''}
                    value={allAccountBalance}
                    valueType="currency"
                />
                <StatsCard
                    title="Total Transactions"
                    icons={<ArrowsLeftRightIcon size={24} />}
                    iconsBackground={theme === "dark" ? '#2563eb' : ''}
                    value={total_trade}
                    valueType="number"
                />

            </div>
            <div className="w-full px-4 mt-6 ">
                <div className={`rounded-lg shadow-sm ${theme === 'dark' ? 'bg-gray-800' : 'bg-white'} p-4`}>
                    <TradeHistoryChartLine />
                    <Divider dashed style={{
                        
                    }}/>
                    <div className="xl:grid grid-cols-8 mb-4 ">
                        <TradeHistoryChartBar />
                        <ProfitChartByUser />
                    </div>
                </div>
            </div>
            <div className="w-full px-4 mt-4">
                <ActiveTradingAccountList />
            </div>
            <div className="w-full px-4 mt-4">
                <UserAccountList />
            </div>
            
        </SidebarLayout>
    );
}
export default MainDashBoard;

